"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function ContactHero() {
  const {
    ref: headerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={headerRef} data-section-id="189635" id="contact-hero" className="relative h-[450px] md:h-[500px] w-full overflow-hidden bg-[#f3ede5] flex items-center">
      {/* 背景圖片層 - 展現陽光灑落與植物交織的溫潤氛圍 */}
      <div className="absolute inset-0 z-0">
        <img src="https://hent.services/wp-content/uploads/2026/05/Contact_TOP_BG.webp" alt="Hent's Flooring Contact Us" className={cn("h-full w-full object-cover transition-transform duration-[3000ms] ease-out opacity-90 object-center", isVisible ? "scale-102" : "scale-100")} />
      
        <div className="absolute inset-0 bg-gradient-to-r from-white/20 via-transparent to-transparent z-10" />
      </div>

      {/* 內容容器 */}
      <div className="container relative z-30 mx-auto px-6 md:px-12 lg:px-20">
        <div className={cn("max-w-3xl transition-all duration-1000 delay-300", isVisible ? "translate-x-0 opacity-100" : "-translate-x-6 opacity-0")}>
          
          {/* 1. 麵包屑導覽：改為細緻的石磚灰，降低視覺權重 */}
          <nav className="mb-8 flex items-center gap-2 text-lg md:text-xl font-sans tracking-[0.2em] text-[#664d46]/60">
            <Link to="/" className="transition-colors hover:text-[#664d46]">HOME</Link>
            <span className="opacity-40">/</span>
            <span className="text-[#664d46] font-medium">CONTACT</span>
          </nav>

          {/* 2. 主標題區塊（依據圖片規範 100% 精準還原） */}
          <div className="flex flex-col items-start">
         
            <h1 className="font-hk-regular text-3xl md:text-4xl font-normal tracking-widest text-[#664d46] leading-tight">
              有些質感，要親自感受
            </h1>
            
         
            <div className="h-[1px] w-10 bg-[#664d46]/30 my-5" />

            <div className="font-sans text-xs md:text-sm font-semibold tracking-[0.25em] text-[#bca18e] uppercase select-none">
              Some things need to be felt
            </div>
          </div>

        
          
        </div>
      </div>
    </section>;
}